import { render, staticRenderFns } from "./therm-tickets-status.vue?vue&type=template&id=95a08ab6"
import script from "./therm-tickets-status.vue?vue&type=script&lang=js"
export * from "./therm-tickets-status.vue?vue&type=script&lang=js"
import style0 from "./therm-tickets-status.vue?vue&type=style&index=0&id=95a08ab6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports